import React from "react";
import { Link, withRouter } from "react-router-dom";
import "./hamburger-menu.css";

export const Renderhamburgermenu = withRouter((props) => {
  const isDisabled = /^\/new\/app\/questionnaire\/\d+\/\d+\/\d+\/\d+\/\d+\/(true|false)\/\d+\/(invitations|assessment)$/.test(props.location.pathname) ||
                     /^\/new\/app\/invitations\/\d+\/\d+\/(true|false)$/.test(props.location.pathname);

  return (
    <React.Fragment>
      {props.reviewMode === false ? (
        <ul className="hamburger-menu">
          <li>
            <Link to={props.link1}>{props.text1}</Link>
          </li>
          <li>
            {isDisabled ? (
              <span className="disabled-link">{props.text2}</span>
            ) : (
              <Link to={props.link2}>{props.text2}</Link>
            )}
          </li>
        </ul>
      ) : (
        <ul className="hamburger-menu">
          <li>
            <Link to={props.link1}>{props.text1}</Link>
          </li>
          <li>{props.text2}</li>
        </ul>
      )}
    </React.Fragment>
  );
});



// WEBPACK FOOTER //
// ./src/new/Components/hamburger/hamburger-menu.jsx